import React, { useState } from "react";
import { AddressmanagerSummaryTile, AddressmanagerSummaryTileTypes } from "./addressmanagerSummaryTiles";
import "./addressmanagerSummary.scss";
import { AddressFilter } from "../constants";
import { useAddressCounts } from "../hooks/useAddressCounts";

export const AddressmanagerSummary: React.FC<{ handleFilterChange: (filter: string) => void }> = ({ handleFilterChange }) => {

    const [selectedFilter, setSelectedFilter] = useState<string>("");

    const { addressCounts, isLoadingAddressCounts } = useAddressCounts();

    const getPercentage = (numerator: number, denominator: number) => {
        if (denominator === 0) return "0";

        const percentage = (numerator / denominator) * 100;
        const rounded = Number(percentage.toFixed(2));

        if (rounded === 0) return "0";

        if (Number.isInteger(rounded)) return `${rounded}`;

        return `${rounded}`;
    };


    return (<div className="xgs-addressmanager-summary">
        <AddressmanagerSummaryTile
            type={AddressmanagerSummaryTileTypes.totalLocations}
            isLoading={isLoadingAddressCounts}
            title="Total Locations"
            value={addressCounts?.total || "0"}
            clicked={false}
            onClick={undefined}
            onClear={undefined}
        />
        <AddressmanagerSummaryTile
            type={AddressmanagerSummaryTileTypes.limitedAccess}
            isLoading={isLoadingAddressCounts}
            title="Limited Access"
            value={addressCounts?.limitedAccessTrue || "0"}
            clicked={selectedFilter === AddressFilter.LimitedAccess}
            onClick={() => {
                setSelectedFilter(AddressFilter.LimitedAccess);
                handleFilterChange(AddressFilter.LimitedAccess)
            }}
            onClear={()=>{
                setSelectedFilter("");
                handleFilterChange("")
            }}
        />
        <AddressmanagerSummaryTile
            type={AddressmanagerSummaryTileTypes.residential}
            isLoading={isLoadingAddressCounts}
            title="Residential"
            value={addressCounts?.residential || "0"}
            clicked={selectedFilter === AddressFilter.Residential}
            onClick={() => {
                setSelectedFilter(AddressFilter.Residential);
                handleFilterChange(AddressFilter.Residential)
            }}
            onClear={()=>{
                setSelectedFilter("");
                handleFilterChange("")
            }}
        />
        <AddressmanagerSummaryTile
            type={AddressmanagerSummaryTileTypes.gateCodeRequired}
            isLoading={isLoadingAddressCounts}
            title="Gate Code Required"
            value={addressCounts?.gateCodeRequiredTrue || "0"}
            clicked={selectedFilter === AddressFilter.GateCodeRequired}
            onClick={() => {
                setSelectedFilter(AddressFilter.GateCodeRequired);
                handleFilterChange(AddressFilter.GateCodeRequired)
            }}
            onClear={()=>{
                setSelectedFilter("");
                handleFilterChange("")
            }}
        />
        <AddressmanagerSummaryTile
            type={AddressmanagerSummaryTileTypes.fullyVerifiedAddress}
            isLoading={isLoadingAddressCounts}
            title="Fully Verified Address"
            value={getPercentage(addressCounts?.fullyVerified || 0, addressCounts?.total || 0).toString() + "%" || "0%"}
            clicked={selectedFilter === AddressFilter.FullyVerified}
            onClick={() => {
                setSelectedFilter(AddressFilter.FullyVerified);
                handleFilterChange(AddressFilter.FullyVerified)
            }}
            onClear={()=>{
                setSelectedFilter("");
                handleFilterChange("")
            }}
        />
    </div>
    )
};